import { Col, Container, Row, Stack } from "react-bootstrap";
import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons";

export default function DaypartHeader({ requestSort, sortConfig }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none">
                <Col xs={3} sm lg={2} onClick={() => requestSort("radio_id")} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span className="text-center">Station</span>
                        <span className="col-1">
                            {sortConfig?.key === "radio_id" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs={3} sm lg={2} onClick={() => requestSort("name", undefined, undefined, true)} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-start">
                        <span className="text-center">Name</span>
                        <span className="col-1">
                            {sortConfig?.key === "name" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs={3} sm={2} lg={1} onClick={() => requestSort("start_time")} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="text-center text-nowrap">Start</span>
                        <span className="col-1">
                            {sortConfig?.key === "start_time" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs={3} sm={2} lg={1} onClick={() => requestSort("end_time")} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="text-center text-nowrap">End</span>
                        <span className="col-1">
                            {sortConfig?.key === "end_time" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                        </span>
                    </Stack>
                </Col>
                <Col xs className=" d-none d-lg-block">
                    Days
                </Col>
            </Row>
        </Container>
    );
}
